<template>
    <v-form v-model="valid" ref="form">
        <v-container fluid>
            <div class="headline">{{__('labels.address')}}</div>
            <div class="subheading">{{__('labels.address_subtitle')}}</div>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-email-field
                            v-model="address.email"
                            name="email"
                            :label="__('labels.address_email')"
                            :rules="rules.email">
                    </s-email-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-email-field
                            v-model="address.repeatEmail"
                            name="repeat_email"
                            :label="__('labels.address_repeat_email')"
                            :rules="rules.repeatEmail"
                    ></s-email-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-text-field
                            v-model="address.company"
                            name="company"
                            :hint="__('labels.address_company_hint')"
                            :label="__('labels.address_company') + ' ' + __('labels.optional')"
                            :rules="rules.company"
                    >
                    </s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-select
                            v-model="address.salutation"
                            :label="__('labels.address_salutation')"
                            name="salutation"
                            browser-autocomplete="false"
                            :items="[__('general.mister'), __('general.miss')]"
                            :rules="rules.salutation">
                    </s-select>
                </v-flex>
                <v-flex xs12 md6>
                    <s-select
                            v-model="address.title"
                            :label="__('labels.address_title')  + ' ' + __('labels.optional')"
                            name="title"
                            browser-autocomplete="false"
                            :items="['Dr.', 'Prof.', 'Prof. Dr.', 'PD', 'PD Dr.']">
                    </s-select>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="address.first_name"
                            :label="__('labels.address_first_name')"
                            name="fname"
                            :rules="rules.first_name">
                    </s-text-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="address.last_name"
                            :label="__('labels.address_last_name')"
                            name="lname"
                            :rules="rules.last_name"
                    ></s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="address.street"
                            :label="__('labels.address_street') + ', ' + __('labels.address_street_number')"
                            name="street"
                            :rules="rules.street">
                    </s-text-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="address.street_suffix"
                            :label="__('labels.address_street_suffix') + ' ' + __('labels.optional')"
                            name="street_suffix"
                            :rules="rules.street_suffix"
                    ></s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="address.zip"
                            :label="__('labels.address_zip')"
                            name="zip"
                            :rules="rules.zip">
                    </s-text-field>
                </v-flex>
                <v-flex xs12 md6>
                    <s-text-field
                            v-model="address.city"
                            :label="__('labels.address_city')"
                            name="city"
                            :rules="rules.city"
                    ></s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-select
                            v-model="address.country_code"
                            :label="__('labels.address_country')"
                            :items="countries"
                            :rules="rules.country_code"
                            name="country"
                            browser-autocomplete="false"
                            :item-text="locale()==='en'?'en_text':'text'"
                            @change="countryChanged"
                    >
                    </s-select>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <s-text-field
                            v-model="address.phone"
                            :label="__('labels.address_phone') + ' ' + __('labels.optional')"
                            name="phone"
                            :rules="rules.phone"
                    ></s-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'

    export default {
        name: "AddressStep",
        computed: {
            ...mapState('form', [
                'countries',
                'address',
            ]),
            taxes: {
                get() {
                    return this.$store.state.form.taxes;
                },
                set(v) {
                    this.$store.commit('form/setTaxes', v);
                }
            },
        },
        data() {
            return {
                valid: false,
                rules: this.$validation.create({
                        email: ['required', 'email', 'maxLen:255'],
                        repeatEmail: ['required', (v) => (v === this.address.email || this.__('errors.emails_not_equal'))],
                        company: ['maxLen:255'],
                        salutation: ['required'],
                        first_name: ['required', 'maxLen:255'],
                        last_name: ['required', 'maxLen:255'],
                        street: ['required', 'maxLen:255'],
                        street_suffix: ['maxLen:255'],
                        zip: ['required', 'maxLen:255'],
                        city: ['required', 'maxLen:255'],
                        country_code: ['required'],
                        phone: ['maxLen:255'],
                    }
                )
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
          ...mapGetters('stepper', [
            'locale',
          ]),
            countryChanged(country) {
                if (
                    (country === 'DE' && (this.taxes !== '0' || this.taxes !== '19'))
                    || (country !== 'DE' && (this.taxes !== 'reverse'))
                ) {
                    this.taxes = '';
                }
            },
            nextButtonClick() {
                if (this.$refs.form.validate()) {
                    this.$cookies.set('address', this.address);
                    this.nextStep();
                } else {
                    this.setError(this.__('messages.form_invalid'));
                }
            },
        },
    }
</script>

<style scoped>

</style>
